import {Injectable} from '@angular/core';
import {GroupConfig, GroupConfigs} from '../../shared/models/config';
import {GetConfigSharedService} from '../../shared/services/get-config-shared.service';

@Injectable({
  providedIn: 'root'
})
export class GetConfigCompaniesService {

  constructor(private getConfigSharedService: GetConfigSharedService) {
  }
  getCompaniesConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigCompaniesFilter()
      ]
    }
  }
  getSubscriptionFilter(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigFilter()
      ]
    }
  }

  getConfigCompaniesFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME_LABEL',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME_LABEL',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_SALESFORCE_ID',
          controlName: ['salesforceIdentifier'],
          placeholder: 'GENERIC_CODE',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_SAP_CODE',
          controlName: ['sapCode'],
          placeholder: 'GENERIC_SAP_CODE',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_COMMENT',
          controlName: ['comment'],
          placeholder: 'GENERIC_COMMENT',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'select',
          label: 'GENERIC_OFFICE',
          controlName: ['office', 'id'],
          placeholder: 'GENERIC_OFFICE',
          data: 'office',
          options: {value: 'id', vue: 'name'},
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_INVOICES_DETAIL_LIST_LOGISTICS_CODE_2',
          controlName: ['code'],
          placeholder: 'GENERIC_INVOICES_DETAIL_LIST_LOGISTICS_CODE_2',
          presentation: 'filter',
          options: {
            show: true
          }
        },
      ]
    }
  }
  getCompanyConfigsSimple(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigCompanyGeneral(),
        this.getConfigCompanyBillingSimple(),
        this.getConfigCompanyMiscCreated(),
        this.getConfigAddress(),
        this.getConfigContact(),
      ]
    }
  }
  getCompanyConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigCompanyGeneral(),
        this.getConfigCompanyBilling(),
        this.getConfigCompanyMiscCreated(),
        this.getConfigAddress(),
        this.getConfigContact(),
      ]
    }
  }
  getAddCompanyConfigs(): GroupConfigs {
    return {
      'groupConfigs': [
        this.getConfigCompanyGeneral(),
        this.getConfigCompanyBillingAdd(),
        this.getConfigCompanyMiscCreated(),
        this.getConfigAddress(),
        this.getConfigContact(),
      ]
    }
  }

  getConfigCompanyMiscCreated(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_CREATED_LABEL',
          controlName: ['createdBy'],
          placeholder: 'GENERIC_CREATED_LABEL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_UPDATED_LABEL',
          controlName: ['updatedBy'],
          placeholder: 'GENERIC_UPDATED_LABEL',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  }
  getConfigCompanyBillingSimple(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_ACCOUNTANCY_CODE',
          controlName: ['LogisticsIdentifier'],
          placeholder: 'GENERIC_ACCOUNTANCY_CODE',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true,
          }
        },
        {
          type: 'input',
          label: 'GENERIC_SAP_CODE',
          controlName: ['sapCode'],
          placeholder: 'GENERIC_SAP_CODE',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true,
          }
        },
        {
          type: 'select',
          label: 'GENERIC_OFFICE',
          controlName: ['office', 'id'],
          placeholder: 'GENERIC_OFFICE',
          data: 'office',
          options: {value: 'id', vue: 'name' , labelShowInDetail: true},
          presentation: 'detail'
        },
        {
          type: 'select',
          label: 'GENERIC_SALES',
          controlName: ['salesId', 'id'],
          placeholder: 'GENERIC_SALES',
          data: 'sales',
          options: {value: 'id', vue: 'name' , labelShowInDetail: true},
          presentation: 'detail'
        },
        {
          type: 'checkBox',
          label: 'GENERIC_BLOCKED',
          controlName: ['blocked'],
          placeholder: 'GENERIC_BLOCKED',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left',
            labelSize: 1,
          }
        },
        {
          type: 'checkBox',
          label: 'GENERIC_GROUP_BY_SITE_ON_THE_INVOICE',
          controlName: ['groupBySite'],
          placeholder: 'GENERIC_GROUP_BY_SITE_ON_THE_INVOICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelSize: 1,
            labelPosition: 'left',
          }
        }
      ]
    }

  }

  getConfigCompanyBilling(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_ACCOUNTANCY_CODE',
          controlName: ['LogisticsIdentifier'],
          placeholder: 'GENERIC_ACCOUNTANCY_CODE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
          }
        },
        {
          type: 'input',
          label: 'GENERIC_SAP_CODE',
          controlName: ['sapCode'],
          placeholder: 'GENERIC_SAP_CODE',
          presentation: 'detail',
          options: {
            show: true,
            labelShowInDetail: true,
          }
        },
        {
          type: 'select',
          label: 'GENERIC_OFFICE',
          controlName: ['office', 'id'],
          placeholder: 'GENERIC_OFFICE',
          data: 'office',
          options: {value: 'id', vue: 'name' , labelShowInDetail: true},
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'GENERIC_SALES',
          controlName: ['salesId', 'id'],
          placeholder: 'GENERIC_SALES',
          data: 'sales',
          options: {value: 'id', vue: 'name' , labelShowInDetail: true},
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'GENERIC_BLOCKED',
          controlName: ['blocked'],
          placeholder: 'GENERIC_BLOCKED',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left',
            labelSize: 1,
          }
        },
        {
          type: 'checkBox',
          label: 'GENERIC_GROUP_BY_SITE_ON_THE_INVOICE',
          controlName: ['groupBySite'],
          placeholder: 'GENERIC_GROUP_BY_SITE_ON_THE_INVOICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelSize: 1,
            labelPosition: 'left',
          }
        }
      ]
    }

  }
  getConfigCompanyBillingAdd(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_ACCOUNTANCY_CODE',
          controlName: ['LogisticsIdentifier'],
          placeholder: 'GENERIC_ACCOUNTANCY_CODE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
          }
        },
        {
          type: 'select',
          label: 'GENERIC_OFFICE',
          controlName: ['office', 'id'],
          placeholder: 'GENERIC_OFFICE',
          data: 'office',
          options: {value: 'id', vue: 'name' , labelShowInDetail: true},
          presentation: 'edit'
        },
        {
          type: 'select',
          label: 'GENERIC_SALES',
          controlName: ['salesId', 'id'],
          placeholder: 'GENERIC_SALES',
          data: 'sales',
          options: {value: 'id', vue: 'name' , labelShowInDetail: true},
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'GENERIC_BLOCKED',
          controlName: ['blocked'],
          placeholder: 'GENERIC_BLOCKED',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left',
            labelSize: 1,
          }
        },
        {
          type: 'checkBox',
          label: 'GENERIC_GROUP_BY_SITE_ON_THE_INVOICE',
          controlName: ['groupBySite'],
          placeholder: 'GENERIC_GROUP_BY_SITE_ON_THE_INVOICE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelSize: 1,
            labelPosition: 'left',
          }
        }
      ]
    }

  }
  getConfigCompanyGeneral(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_NAME',
          controlName: ['name'],
          placeholder: 'GENERIC_NAME',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
          }
        },
        // {
        //   type: 'input',
        //   label: 'GENERIC_LANGUAGE',
        //   controlName: ['languageName'],
        //   placeholder: 'GENERIC_LANGUAGE',
        //   presentation: 'edit',
        //   options: {
        //     show: true,
        //     labelShowInDetail: true,
        //   }
        // },
        {
          type: 'select',
          label: 'GENERIC_LANGUAGE',
          controlName: ['language', 'id'],
          placeholder: 'GENERIC_LANGUAGE',
          data: 'companieslanguage',
          options: {value: 'id', vue: 'name' , labelShowInDetail: true},
          presentation: 'edit'
        },
        {
          type: 'input',
          label: 'GENERIC_VAT',
          controlName: ['vat'],
          placeholder: 'GENERIC_VAT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
          }
        },
        {
          type: 'checkBox',
          label: 'GENERIC_ACTIVE',
          controlName: ['active'],
          placeholder: 'GENERIC_ACTIVE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left'
          }
        }
      ]
    }
  };
  getConfigAddress(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_1',
          controlName: ['line1'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_1',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_2',
          controlName: ['line2'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_2',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_LINE_3',
          controlName: ['line3'],
          placeholder: 'ORDER_FORM_ADDRESS_LINE_3',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_ZIP',
          controlName: ['zip'],
          placeholder: 'ORDER_FORM_ADDRESS_ZIP',
          presentation: 'edit',
          options: {
            show: true,
            shortInput: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_CITY',
          controlName: ['city'],
          placeholder: 'ORDER_FORM_ADDRESS_CITY',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_ADDRESS_STATE',
          controlName: ['state'],
          placeholder: 'ORDER_FORM_ADDRESS_STATE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'select',
          label: 'ORDER_FORM_ADDRESS_COUNTRY',
          controlName: ['countryForm', 'name'],
          placeholder: 'ORDER_FORM_ADDRESS_COUNTRY',
          data: 'country',
          options: {
            show: true,
            value: 'name',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'edit'
        },
      ]
    }
  };

  getConfigContact(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_NAME',
          controlName: ['name'],
          placeholder: 'ORDER_FORM_CONTACT_NAME',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_SURNAME',
          controlName: ['surname'],
          placeholder: 'ORDER_FORM_CONTACT_SURNAME',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_PHONE',
          controlName: ['phone'],
          placeholder: 'ORDER_FORM_CONTACT_PHONE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_MOBILE',
          controlName: ['mobile'],
          placeholder: 'ORDER_FORM_CONTACT_MOBILE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_EMAIL',
          controlName: ['email'],
          placeholder: 'ORDER_FORM_CONTACT_EMAIL',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
        {
          type: 'input',
          label: 'ORDER_FORM_CONTACT_DEPARTMENT',
          controlName: ['department'],
          placeholder: 'ORDER_FORM_CONTACT_DEPARTMENT',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true
          }
        },
      ]
    }
  };
  getConfigFilter(): GroupConfig {
    return {
      'config': [
        {
          type: 'input',
          label: 'GENERIC_SUBSCRIPTION_NAME',
          controlName: ['subscriptionName'],
          placeholder: 'GENERIC_SUBSCRIPTION_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CLIENT',
          controlName: ['clientName'],
          placeholder: 'GENERIC_CLIENT',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'input',
          label: 'GENERIC_CONTRACT_NAME',
          controlName: ['contractName'],
          placeholder: 'GENERIC_CONTRACT_NAME',
          presentation: 'filter',
          options: {
            show: true
          }
        },
        {
          type: 'dateRangePicker',
          label: 'GENERIC_START_DATE',
          controlName: ['startBillingRangeStart' , 'startBillingRangeEnd'],
          placeholder: 'GENERIC_START_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'dateRangePicker',
          label: 'GENERIC_END_DATE',
          controlName: ['endBillingRangeStart' , 'endBillingRangeEnd'],
          placeholder: 'GENERIC_END_DATE',
          options: {
            show: true,
            labelShowInDetail: true,
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null,
              daysOfWeekDisable: false,
              widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
              }
            }
          },
          presentation: 'filter'
        },
        {
          type: 'dateRangePicker',
          label: 'ORDERS_LIST_DELIVERY_DATE',
          controlName: ['deliveryDateRangeStart' , 'deliveryDateRangeEnd'],
          placeholder: 'ORDERS_LIST_DELIVERY_DATE',
          options: {
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: null
            }
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_SERVICES_LABEL',
          controlName: ['service', 'id'],
          placeholder: 'GENERIC_SERVICES_LABEL',
          data: 'servicesList',
          options: {
            value: 'id',
            vue: 'name'
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_PRODUCT',
          controlName: ['productID', 'id'],
          placeholder: 'GENERIC_PRODUCT',
          data: 'productsCompleteList',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'select',
          label: 'GENERIC_LIST_STATUS',
          controlName: ['status', 'id'],
          placeholder: 'GENERIC_LIST_STATUS',
          data: 'statusFilter',
          options: {
            show: true,
            value: 'id',
            vue: 'name',
            labelShowInDetail: true
          },
          presentation: 'filter'
        },
        {
          type: 'input',
          label: 'GENERIC_PRICE',
          controlName: ['price'],
          placeholder: 'GENERIC_PRICE',
          presentation: 'filter',
          options: {
            show: true,
            inputType: {
              type: 'number',
              step: 0.1
            }
          }
        },
      ]
    }
  }
  getConfigInvoicesGenerate(): GroupConfig {
    return {
      'config': [
        {
          type: 'datePicker',
          label: 'GENERIC_BILLING_START_DATE',
          controlName: ['startDate'],
          placeholder: 'GENERIC_BILLING_START_DATE',
          options: {
            datePicker: {
              minDate: false,
              useCurrent: false,
              defaultDate: false,
              daysOfWeekDisable: false,
              enabledFirstDaysOfMonth: true,
            }
          },
          presentation: 'edit'
        },
        // {
        //   type: 'datePicker',
        //   label: 'GENERIC_END_DATE',
        //   controlName: ['endDate'],
        //   placeholder: 'GENERIC_END_DATE',
        //   options: {
        //     datePicker: {
        //       minDate: false,
        //       useCurrent: false,
        //       defaultDate: false,
        //       daysOfWeekDisable: false
        //     }
        //   },
        //   presentation: 'edit'
        // },
        {
          type: 'select',
          label: 'GENERIC_INVOICE_RECURRENCE',
          controlName: ['recurrence', 'id'],
          placeholder: 'GENERIC_INVOICE_RECURRENCE',
          data: 'recurrenceInvoicesShort',
          options: {
            value: 'id',
            vue: 'name'
          },
          presentation: 'edit'
        },
        {
          type: 'checkBox',
          label: 'GENERIC_GROUP_BY_SITE',
          controlName: ['isGroupSites'],
          placeholder: 'GENERIC_GROUP_BY_SITE',
          presentation: 'edit',
          options: {
            show: true,
            labelShowInDetail: true,
            labelPosition: 'left'
          }
        },

      ]
    }
  }
}
